import { auditsRelation } from 'app/jsd/helpers';

export default {
    mapper: {
        relations: {
            belongsTo: {
                facility: {
                    foreignKey: 'facility_id',
                    localField: 'facility',
                },
            },
            belongsToMany: {
                line: {
                    foreignKey: 'id',
                    localField: 'lines',
                },
            },
            hasMany: {
                invoice: {
                    foreignKey: 'patient_name_id',
                    localField: 'invoices',
                },
            },
            morphMany: {
                ...auditsRelation('patientName'),
            },
        },
    },
};
